export const environmentBase = {
    name: 'GROUP OPERATIONS'
};

export const defaultMemberStartDate = '7/1/';
export const defaultMemberEndDate = '6/30/';
